import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { redirectIfNeeded } from "../utils/helpers"

import SliceZone from "../components/slice-zone"
import { withPreview } from "gatsby-source-prismic"

export const query = graphql`
  query IndexQueryV2($uid: String, $lang: String) {
    prismicCandidatesV2(uid: { eq: $uid }, lang: { eq: $lang }) {
      uid
      lang
      alternate_languages {
        id
        lang
        type
        uid
      }
      data {
        meta_image {
          url
        }
        meta_title
        meta_keywords
        meta_description
        body {
          ... on PrismicCandidatesV2BodyHeroSection {
            id
            slice_type
            primary {
              link_text
              hero_subtitle: subtitle
              theme
              has_waves_cutout
              hero_title: title
              button_text
              link {
                url
                type
                target
              }
              background_image {
                url
              }
            }
          }
          ... on PrismicCandidatesV2BodyHeroSectionCandidate {
            id
            slice_type
            primary {
              hero_subtitle: subtitle
              theme
              hero_title: title
              search_label
              search_placeholder
              background_image {
                url
              }
            }
          }
          ... on PrismicCandidatesV2BodyProcess {
            id
            slice_type
            primary {
              process_title: title
            }
            items {
              process_item_title: title
              image {
                url
              }
              process_body {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyInfoWithIcons {
            id
            slice_type
            primary {
              info_with_icons_subtitle: subtitle
              info_with_icons_title: title
            }
            items {
              info_body {
                html
                raw
                text
              }
              link_text
              info_with_icons_item_title: title
              link_url {
                url
                type
                target
              }
              button_icon {
                url
              }
            }
          }
          ... on PrismicCandidatesV2BodyPartnersCarousel {
            id
            slice_type
            primary {
              title_is_bold
              partners_carousel_title: title
            }
            items {
              image {
                url
              }
            }
          }
          ... on PrismicCandidatesV2BodyTestimonialCarousel {
            id
            slice_type
            primary {
              testimonial_carousel_title: title
            }
            items {
              name
              role
              testimonial_carousel_text {
                html
                raw
                text
              }
              image {
                localFile {
                  childImageSharp {
                    fixed(width: 80) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
          }
          ... on PrismicCandidatesV2BodyFaqVideo {
            id
            slice_type
            slice_label
            primary {
              button_text
              faq_video_title: title
              faq_video_subtitle: subtitle
              button_url {
                url
                type
                target
              }
            }
            items {
              tab_title
              video_number
            }
          }
          ... on PrismicCandidatesV2BodyFeatures {
            id
            slice_type
            primary {
              features_title: title
              button_text
              button_link {
                url
                type
                target
              }
              body1 {
                html
                raw
                text
              }
              image {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 700, quality: 80) {
                      ...GatsbyImageSharpFluid_noBase64
                    }
                  }
                }
              }
            }
          }
          ... on PrismicCandidatesV2BodyContentBlog {
            id
            slice_type
            slice_label
            primary {
              content_blog {
                html
                raw
                text
              }
              text_color
            }
          }
          ... on PrismicCandidatesV2BodyBubbles {
            id
            slice_type
            slice_label
            primary {
              anchor_id
              subtitle_bubbles
              title {
                html
                raw
                text
              }
            }
            items {
              image {
                url
              }
              text {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyScreenshots {
            id
            slice_type
            slice_label
            items {
              image {
                url
              }
              text {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
            primary {
              anchor_id
              subtitle {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyTiledContent {
            id
            slice_type
            slice_label
            items {
              cta_button
              cta_url
              image {
                url
              }
              text {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
            primary {
              subtitle {
                html
                raw
                text
              }
              anchor_id
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodySingleColumn {
            id
            slice_type
            slice_label
            items {
              text {
                html
                raw
                text
              }
            }
            primary {
              anchor_id
              subtitle {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyPool {
            id
            slice_type
            slice_label
            items {
              image {
                url
              }
              linked
            }
            primary {
              anchor_id
              subtitle {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyPlans {
            id
            slice_type
            slice_label
            items {
              benefits {
                html
                raw
                text
              }
              frequency
              price
              subtitle
              title {
                html
                raw
                text
              }
            }
            primary {
              anchor_id
              subtitle {
                text
                raw
                html
              }
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyContactUs {
            id
            slice_type
            slice_label
            primary {
              anchor_id
            }
          }
          ... on PrismicCandidatesV2BodyCta {
            id
            slice_type
            slice_label
            primary {
              cta_centered {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyPageHead {
            id
            slice_type
            slice_label
            primary {
              subtitle {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyLogoCarousel {
            id
            slice_type
            slice_label
            items {
              logo {
                url
              }
            }
            primary {
              anchor_id
              subtitle_carousel
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyCustomTiled {
            id
            slice_type
            slice_label
            primary {
              anchor_id
              subtitle {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
            items {
              text_order
              button_url
              button_text
              text {
                raw
              }
              title {
                raw
              }
              image {
                url
                alt
              }
            }
          }
          ... on PrismicCandidatesV2BodyInfoBox {
            id
            slice_type
            slice_label
            primary {
              description {
                html
                raw
                text
              }
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyOverviewSection {
            id
            slice_type
            slice_label
            items {
              section_anchor_id
              section_title
            }
            primary {
              anchor_id
              overview_title
            }
          }
          ... on PrismicCandidatesV2BodyFlowChart {
            id
            slice_type
            slice_label
            items {
              flow
            }
            primary {
              title {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyVerticalSpace {
            id
            slice_type
            slice_label
            primary {
              size
            }
          }
          ... on PrismicCandidatesV2BodyLinkBox {
            id
            slice_type
            slice_label
            items {
              link_url {
                url
                link_type
                slug
              }
              link_title
            }
            primary {
              link_box_title
            }
          }
          ... on PrismicCandidatesV2BodyQuoteBox {
            id
            slice_type
            slice_label
            primary {
              quote_text {
                html
                raw
                text
              }
            }
          }
          ... on PrismicCandidatesV2BodyDivider {
            id
            slice_type
          }
        }
      }
    }
  }
`

const CandidatesV2Template = ({ data, pageContext, uri, location }) => {
  const { lang: locale } = pageContext
  useEffect(() => {
    redirectIfNeeded({ locale, location })
  }, [])

  const doc = data.prismicCandidatesV2.data

  if (!doc) return null
  const { meta_title, meta_description, meta_keywords, meta_image } = doc

  return (
    <Layout
      metadata={{
        title: meta_title,
        description: meta_description,
        keywords: meta_keywords,
        image: meta_image && meta_image.url,
      }}
      mainPage="candidates"
      locale={pageContext.lang}
      path={location && location.pathname}
    >
      {doc.body && (
        <SliceZone
          shouldWrapDoc
          allSlices={doc.body}
          locale={locale}
          path={location && location.pathname}
        />
      )}
    </Layout>
  )
}

export default withPreview(CandidatesV2Template)
